import { Flex, type FlexProps } from '@chakra-ui/react'
import React, { ForwardedRef, forwardRef } from 'react'
import { useCustomTooltipStyles } from '~/components/shared/componentStyles/CustomTooltip.style'
import { PopoverContent } from '~/components/ui/popover'
import { ZIndex } from '~/types/ThemeTypes'

export const CustomTooltipContainer = forwardRef(
  (
    { children, onMouseEnter, onMouseLeave, ...rest }: FlexProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const styles = useCustomTooltipStyles()

    return (
      <Flex
        ref={ref}
        zIndex={ZIndex.popover}
        position="relative"
        css={{ ...rest }}
      >
        <PopoverContent
          width="fit-content"
          bg="transparent"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <Flex css={styles.container}>{children}</Flex>
        </PopoverContent>
      </Flex>
    )
  },
)
